import "./MatchStartCountdown.css";

import { useTranslation } from "react-i18next";

import { useTimeLeft } from "../../../../hooks";

export const MatchStartCountdown = ({
  matchStartTime,
}: {
  matchStartTime: number | string;
}) => {
  const { days, hours, minutes, seconds } = useTimeLeft({
    expiry: matchStartTime,
  });
  const { t } = useTranslation();

  // Once the kickoff time has passed but the API still reports the match as
  // upcoming (no PLAYING status yet), hide the digit timer and show a waiting
  // message — we'd otherwise render "00 : 00 : 00", which looks wrong.
  const hasReachedZero =
    !days && hours === "00" && minutes === "00" && seconds === "00";

  if (hasReachedZero) {
    return (
      <div className="match-begin-countdown-container">
        <p className="match-begin-label">
          {t("matchStatus.matchAboutToBegin", {
            defaultValue: "Match about to begin",
          })}
        </p>
      </div>
    );
  }

  return (
    <div className="match-begin-countdown-container">
      <p className="match-begin-label">{t("matchStatus.matchBeginsIn")}</p>
      <div className="match-begin-countdown-timer">
        {!!days && (
          <div className="match-begin-countdown-unit">
            <span className="match-begin-countdown-timer-number">
              {days < 10 ? `0${days}` : days}
            </span>
            <span className="match-begin-countdown-unit-label">
              {t("abbreviation.days")}
            </span>
          </div>
        )}
        <div className="match-begin-countdown-unit">
          <span className="match-begin-countdown-timer-number">{hours}</span>
          <span className="match-begin-countdown-unit-label">
            {t("abbreviation.hours")}
          </span>
        </div>
        <div className="match-begin-countdown-unit">
          <span className="match-begin-countdown-timer-number">{minutes}</span>
          <span className="match-begin-countdown-unit-label">
            {t("abbreviation.minutes")}
          </span>
        </div>
        <div className="match-begin-countdown-unit">
          <span className="match-begin-countdown-timer-number">{seconds}</span>
          <span className="match-begin-countdown-unit-label">
            {t("abbreviation.seconds")}
          </span>
        </div>
      </div>
    </div>
  );
};
